import { defineComponent as _defineComponent } from 'vue'
import LayoutGrid from '@/views/dashboard/LayoutGrid.vue';
import WidgetContainer from '@/components/Charts/widgetContainer/WidgetContainer.vue';
import {
  availableDashboardLayouts,
  DashboardLayout,
} from '@/models/Charts/dashboardDefinition';
import WidgetDefinition from '@/models/Charts/widgetDefinition';
import { WidgetEnum } from '@/models/enums/WidgetEnum';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BendIntradayAvailability',
  props: {
    selectedDevices: null,
    selectedShifts: null
  },
  setup(__props: any) {

const props = __props as {
  selectedDevices: string[];
  selectedShifts: number[];
};



const tableViewLayout = availableDashboardLayouts[DashboardLayout.OneByOne];

const intradayAvailabilityWidgetDefinition = computed<WidgetDefinition>(
  () =>
    new WidgetDefinition(
      WidgetEnum.BendIntradayAvailabilityTable,
      props.selectedDevices,
      undefined,
      props.selectedShifts,
    ),
);

return { __sfc: true,props, tableViewLayout, intradayAvailabilityWidgetDefinition, LayoutGrid, WidgetContainer }
}

})